import React, { Component } from 'react';
import golbeldata from '../data.json';
import { Link, Route, Switch } from 'react-router-dom';

class AppTopHeader extends Component {

    componentDidMount() {

    }
    render() {
        return (<div id="top-header">
            <div class="container">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="th-text pull-left">
                            <div class="th-item"> <a href="#"><i class="fa fa-phone"></i> {this.props.data.phone}</a> </div>
                            <div class="th-item"> <a href="#"><i class="fa fa-envelope"></i> {this.props.data.Email}</a></div>
                        </div>
                    </div>
                    <div class="col-xs-6">
                        <div class="th-text pull-right">
                            <div class="th-item">
                                <div class="social-icons"> <a href="#"><i class="fa fa-facebook"></i></a> <a href="#"><i class="fa fa-twitter"></i></a> <a href="#"><i class="fa fa-youtube-play"></i></a> </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }
}
export default AppTopHeader;



// WEBPACK FOOTER //
// ./src/components/AppTopHeader.js